import muster from '@dbk-legacy/muster';
import { variable } from '@dbk-legacy/muster/helpers';
import { getValues, watchValues, ref, call } from '@dbk-legacy/muster/utils';
import {
  validateRoute, initiateDiscoveryAssets, discoveryAssetMap
} from './utils/disco-util';

export default () => muster()
  .path('discovery.init', {
    call: async ({ req }, { get, set, call, watchValues }) => {
      initiateDiscoveryAssets();
    },
  })
  .path('discovery.verifyPath', ({ res }, { get }) =>
    watchValues(get('ui.history.currentLocation.pathname'))
      .map(pathname => ({
        path: 'discovery.verifyPath',
        value: pathname,
      }))
  )

  .path('discovery.verify', {
    call: async ({ req }, { get, set, call, watchValues }) => {
      const languageCode = await getValues(get('auth.langCode'));
      const [route, history] = await getValues(get([
        'ui.history.currentLocation.pathname',
        'discovery.history']));
      var routes = route && route.split("/");
      var routeName = "/" + routes.pop();
      var currentDiscoveryIDs = validateRoute(routeName, history);
      if (currentDiscoveryIDs.length != 0) {
        var currentDiscovery = currentDiscoveryIDs[0];
        const imageUrls = discoveryAssetMap[currentDiscovery];
        set('discovery.imageUrls', imageUrls);
        set('discovery.currentDiscoveryID', currentDiscovery);
        set('discovery.currentDiscoveryIDs', currentDiscoveryIDs);
        set('discovery.visible', true);
        const visible = await getValues(get('discovery.visible'));
      } else {
        set('discovery.currentDiscoveryID', '');
        set('discovery.currentDiscoveryIDs', []);
        set('discovery.visible', false);
      }
    }
  })
  .path('discovery.new', {
    call: async ({ req }, { get, set, call, watchValues }) => {
      const [route, history, currentDiscoveryIDs] = await getValues(get([
        'ui.history.currentLocation.pathname',
        'discovery.history',
        'discovery.currentDiscoveryIDs']))
      const newHistory = history.concat(currentDiscoveryIDs[0])
      set('discovery.history', newHistory)
      set('discovery.visible', false);

      if (currentDiscoveryIDs.length > 1) {
        await set('discovery.validate', true);
      } else {
        await set('discovery.validate', false);
      }
      const response = await getValues(get(`roster.data.discovery.new.["${currentDiscoveryIDs[0]}"]`));
    }
  })
  .path('discovery.visible', variable(false))
  .path('discovery.currentDiscoveryID', variable(''))
  .path('discovery.currentDiscoveryIDs', variable([]))
  .path('discovery.imageUrls', variable([]))
  .path('discovery.validate', variable(false))
